import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { RangePreset, StatusFilter } from "./types";

interface Props {
  range: RangePreset;
  setRange: (r: RangePreset) => void;
  customStart: string;
  setCustomStart: (s: string) => void;
  customEnd: string;
  setCustomEnd: (s: string) => void;
  template: string;
  setTemplate: (t: string) => void;
  status: StatusFilter;
  setStatus: (s: StatusFilter) => void;
  templates: string[];
}

export function EmailFilters({
  range, setRange, customStart, setCustomStart, customEnd, setCustomEnd,
  template, setTemplate, status, setStatus, templates,
}: Props) {
  return (
    <>
      <div className="grid gap-3 md:grid-cols-4">
        <div className="space-y-1.5">
          <Label className="text-xs uppercase text-muted-foreground">Time range</Label>
          <div className="flex flex-wrap gap-1">
            {(["24h", "7d", "30d", "custom"] as RangePreset[]).map((r) => (
              <Button
                key={r}
                type="button"
                size="sm"
                variant={range === r ? "default" : "outline"}
                onClick={() => setRange(r)}
              >
                {r === "24h" ? "Last 24h" : r === "7d" ? "Last 7 days" : r === "30d" ? "Last 30 days" : "Custom"}
              </Button>
            ))}
          </div>
        </div>

        {range === "custom" ? (
          <>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase text-muted-foreground">Start</Label>
              <Input type="datetime-local" value={customStart} onChange={(e) => setCustomStart(e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase text-muted-foreground">End</Label>
              <Input type="datetime-local" value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} />
            </div>
          </>
        ) : (
          <div className="md:col-span-2" />
        )}

        <div className="space-y-1.5">
          <Label className="text-xs uppercase text-muted-foreground">Template</Label>
          <Select value={template} onValueChange={setTemplate}>
            <SelectTrigger>
              <SelectValue placeholder="All templates" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All templates</SelectItem>
              {templates.map((t) => (
                <SelectItem key={t} value={t}>{t}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid gap-3 md:grid-cols-4">
        <div className="space-y-1.5">
          <Label className="text-xs uppercase text-muted-foreground">Status</Label>
          <Select value={status} onValueChange={(v) => setStatus(v as StatusFilter)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All statuses</SelectItem>
              <SelectItem value="sent">Sent</SelectItem>
              <SelectItem value="failed">Failed</SelectItem>
              <SelectItem value="suppressed">Suppressed</SelectItem>
              <SelectItem value="pending">Pending</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </>
  );
}
